import { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds } from "../../Ads";
import imageUrl from "../../../images/eid-adha.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import MainCalculatorsList from './MainCalculators';
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import moment from 'moment-hijri';
const TITLE = "Berapa Hari Lagi Idul Fitri 2026 - Hitung Mundur Idul Fitri 2026";
const DESCRIPTION = "Berapa hari lagi Idul Fitri, Idul Fitri 2026, kapan Idul Fitri, berapa hari lagi lebaran, kapan lebaran 2026, tanggal Idul Fitri 2026, jadwal Idul Fitri 2026, berapa hari lagi Idul Fitri 2026, Idul Fitri 2024, berapa hari lagi Idul Fitri, berapa hari lagi lebaran, Idul Fitri 2026, berapa hari lagi Idul Fitri 2026, jadwal Idul Fitri 2024, tanggal lebaran, hitung mundur Idul Fitri 2026, kapan Idul Fitri, berapa hari lebaran, Idul Fitri, tanggal Idul Fitri, lebaran 2026, berapa hari lagi Idul Fitri, lebaran Idul Fitri 2026, 1447 Hijriah, berapa hari lagi Idul Fitri 2026, sisa hari Idul Fitri, berapa lama lagi Idul Fitri 2026, jadwal Idul Fitri 2026, Idul Fitri Mubarak, tanggal Idul Fitri 2026, berapa hari lagi lebaran Idul Fitri, Idul Fitri 2026";
const KEYWORDS = "berapa hari lagi Idul Fitri, Idul Fitri 2026, kapan Idul Fitri, berapa hari lagi lebaran, kapan lebaran 2026, tanggal Idul Fitri 2026, jadwal Idul Fitri 2026, berapa hari lagi Idul Fitri 2026, Idul Fitri 2024, hitung mundur Idul Fitri, lebaran 2026, berapa hari lagi lebaran";
const OG_URL = "https://do-calculate.com/articles-id/eid-fatr";
function Ramadan() {
    const [eidDates, setEidDates] = useState([
        { name: 'Idul Fitri 2026', date: new Date("2026-03-20T00:00:00") },
        { name: 'Idul Fitri 2027', date: new Date("2027-03-10T00:00:00") },
        { name: 'Idul Fitri 2028', date: new Date("2028-02-27T00:00:00") },
        { name: 'Idul Fitri 2029', date: new Date("2029-02-15T00:00:00") }
    ]);
    const nextEid = eidDates.find(d => d.name === 'Idul Fitri 2026')?.date || new Date("2026-03-20T00:00:00");
    const dayNameIndonesian = nextEid.toLocaleDateString('id-ID', { weekday: 'long' });
    useEffect(() => {
        async function fetchEidDates() {
            try {
                const datesCol = collection(db, "dates");
                const querySnapshot = await getDocs(datesCol);
                let fetchedEid2026Date = null;
                const newEidDates = [];
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    if (data.eid_fitr) {
                        const date = data.eid_fitr.toDate ? data.eid_fitr.toDate() : new Date(data.eid_fitr);
                        if (date.getFullYear() === 2026) {
                            fetchedEid2026Date = date;
                            newEidDates.push({ name: 'Idul Fitri 2026', date: date });
                        }
                    }
                });
                if (fetchedEid2026Date) {
                    setEidDates(prevDates =>
                        prevDates.map(item =>
                            item.name === 'Idul Fitri 2026'
                                ? { ...item, date: fetchedEid2026Date }
                                : item
                        )
                    );
                } else {
                    console.warn("No Eid al-Fitr 2026 date found in DB. Using default.");
                }
            } catch (error) {
                console.error("Error fetching Eid dates:", error);
            }
        }
        fetchEidDates();
    }, []);
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(nextEid));
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(nextEid));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft, nextEid]);
    return (
        <div className="ltr">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>
                Berapa Hari Lagi Idul Fitri 2026
            </h1>
            <div>
                <BlinkingText
                    text={`Berapa hari lagi Idul Fitri: Diperkirakan Idul Fitri 2026 dimulai hari ${dayNameIndonesian} tanggal ${nextEid?.toLocaleDateString('en-GB')} Masehi dan ${moment(nextEid).format('iDD/iMM/iYYYY')} Hijriah.`}
                />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px' }}>
                    <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th className="bmi-header">Hari</th>
                                <th className="bmi-header">Jam</th>
                                <th>Menit</th>
                                <th>Detik</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td id="days">{timeLeft.days}</td>
                                <td id="hours">{timeLeft.hours}</td>
                                <td id="minutes">{timeLeft.minutes}</td>
                                <td id="seconds">{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className='p-3 mb-2 bg-success text-white' style={{ color: '#333', fontSize: '36px', textAlign: 'center' }}>Jadwal Idul Fitri Mendatang</h2>
                        <table style={{ fontSize: '24px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Jadwal Idul Fitri</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Tanggal</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Sisa Hari</th>
                                </tr>
                            </thead>
                            <tbody>
                                {eidDates.map((eid, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '12px' }}>{eid.name}</td>
                                        <td style={{ padding: '12px' }}>{eid.date.toLocaleDateString('en-GB')}</td>
                                        <td style={{ padding: '12px' }}>{calculateTimeLeft(eid.date).days} hari</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col">
                    <MainCalculatorsList />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>Berapa Hari Lagi Idul Fitri 2026</h3>
                    <p>
                        Dalam artikel ini, kami menyajikan hitung mundur lengkap menuju Idul Fitri yang mulia, agar Anda selalu mengetahui berapa hari lagi hari raya yang istimewa ini tiba. Banyak di antara kita yang bertanya berapa hari lagi Idul Fitri, oleh karena itu kami hadirkan hitung mundur Idul Fitri agar Anda dapat mengetahui berapa hari lagi Idul Fitri, berapa hari tersisa hingga Idul Fitri. Lihat hitung mundur Idul Fitri di atas.
                    </p>
                    <p>
                        Berdasarkan situs <a href='/calculator/id/gregorian_to_hijri/'>konversi tanggal</a>, Idul Fitri 2026 bertepatan dengan hari Sabtu {nextEid?.toLocaleDateString('en-GB')} Masehi dan {moment(nextEid).format('iDD/iMM/iYYYY')} Hijriah. Anda dapat melihat hitung mundur Idul Fitri 2026 di artikel ini.
                    </p>
                    <p>Temukan di sini hitung mundur Idul Fitri, di mana Anda dapat mengetahui berapa hari lagi Idul Fitri yang mulia.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        Hitung Berapa Hari Lagi Idul Fitri
                    </h3>
                    <p>
                        Melalui program hitung mundur Idul Fitri, Anda dapat mengetahui berapa hari lagi Idul Fitri dalam kalender Masehi maupun Hijriah, serta mengetahui sisa hari menuju Idul Fitri dalam hitungan hari, dan kapan Idul Fitri tiba. Selamat merayakan Idul Fitri, semoga Allah menerima amal ibadah kita semua.
                    </p>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        Idul Fitri
                    </h3>
                    <p>
                        Hari raya adalah salah satu syiar agama dan lambang kebesarannya. Jiwa manusia diciptakan dengan kecintaan terhadap hari raya dan kegembiraan merayakannya. Sunnah Nabi SAW telah menetapkan disyariatkannya Idul Fitri dan Idul Adha. Dari Anas RA, ia berkata: "Nabi SAW datang ke Madinah dan penduduknya memiliki dua hari untuk bermain, maka beliau bersabda: 'Sesungguhnya Allah telah menggantikan keduanya dengan yang lebih baik: Idul Fitri dan Idul Adha.'" (HR. Abu Dawud).
                    </p>
                    <div>
                        <br />
                        <img src={imageUrl} alt="Berapa hari lagi Idul Fitri"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        Adab-adab Hari Raya:
                    </h3>
                    <p>
                        – Mandi dan berhias untuk hari raya. Hal ini diriwayatkan dari sejumlah sahabat dan generasi setelahnya, mengikuti teladan Nabi SAW. Ibnu Qayyim berkata: "Beliau SAW mengenakan pakaian terbaiknya untuk hari raya, dan beliau memiliki jubah khusus yang dikenakan saat Idul Fitri, Idul Adha, dan Jumat."
                        Adapun wanita, apabila keluar untuk shalat Idul Fitri dan lainnya, hendaknya keluar dalam kondisi yang diizinkan Nabi SAW, yaitu tidak memakai wewangian sebagaimana sabda beliau: "Janganlah kalian mencegah hamba-hamba Allah (wanita) dari masjid-masjid Allah, namun hendaklah mereka keluar tanpa memakai wewangian." (HR. Abu Dawud). <br />
                        Ibnu Hajar berkata: "Larangan wewangian berlaku pula untuk hal-hal semakna dengannya, karena sebab larangannya adalah dapat membangkitkan syahwat, seperti pakaian indah, perhiasan yang tampak, hiasan berlebihan, dan bercampur dengan laki-laki." <br />
                        Pada Idul Fitri, disyariatkan bertakbir mulai dari malam hari raya hingga datangnya waktu shalat, sebagaimana ditetapkan bahwa Nabi SAW keluar pada hari Idul Fitri sambil bertakbir hingga tiba di mushalla, dan terus bertakbir hingga selesai shalat, kemudian berhenti bertakbir.
                    </p>
                    Sumber: <a href='https://www.islamweb.net/id/article/189088/'>Islam Web</a>
                    <ul>
                    </ul>
                </div>
                <br />
            </div>
        </div>
    );
}
export default Ramadan;
